{
  "possibleTypes": {
    "AcceptInvitationResponse": [
      "AcceptInvitation",
      "NotFoundInvitationError",
      "ServerError"
    ],
    "Activity": [
      "DailyUsageActivity",
      "FuelDispatchActivity",
      "StockControlActivity",
      "WorkOrderActivity"
    ],
    "AddCompanyResponse": [
      "AddCompany",
      "ServerError"
    ],
    "AddFixedAssetResponse": [
      "DuplicatedMachineError",
      "Machine"
    ],
    "AddFuelDispatchedReportPayload": [
      "FuelDispatchedReport"
    ],
    "AddHeavyEquipmentResponse": [
      "DuplicatedMachineError",
      "Machine"
    ],
    "AddMachineConsumablePayload": [
      "MachineConsumableItem"
    ],
    "AddMaintenancePlanPayload": [
      "MaintenancePlanItem"
    ],
    "AddMobilityResponse": [
      "DuplicatedMachineError",
      "Machine"
    ],
    "AddRoleResponse": [
      "DuplicatedRoleError",
      "Employee",
      "Invitation"
    ],
    "AddServiceReportPayload": [
      "DailyReportItem"
    ],
    "AddStockControlReportPayload": [
      "DuplicatedReportDateError",
      "StockControlReport"
    ],
    "AddTruckResponse": [
      "DuplicatedMachineError",
      "Machine"
    ],
    "AddWorkOrderPayload": [
      "ItemWorkOrder"
    ],
    "AssignMaintenancePlanBatchPayload": [
      "AssignMaintenancePlanBatchSuccess"
    ],
    "AssignWorkOrderPayload": [
      "ItemWorkOrder"
    ],
    "AuthAddDailyReportResponse": [
      "AuthCheckAddDailyReport",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthAddProjectResponse": [
      "AuthCheckAddProject",
      "AuthorizationError",
      "DuplicatedProjectError",
      "ServerError"
    ],
    "AuthAddRoleResponse": [
      "AuthCheckAddRole",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthCheckGetMachineTypesResponse": [
      "AuthCheckGetMachineTypes",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthDeleteAvailableReportResponse": [
      "AuthCheckDeleteAvailableReport",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthDeleteDailyReportResponse": [
      "AuthCheckDeleteDailyReport",
      "AuthorizationError",
      "NotFoundDailyReportError",
      "ServerError"
    ],
    "AuthDeleteOutOfServiceReportResponse": [
      "AuthCheckDeleteOutOfServiceReport",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthDeleteRoleResponse": [
      "AuthCheckDeleteRole",
      "AuthorizationError",
      "NotFoundRoleError",
      "ServerError"
    ],
    "AuthGetCompanyResponse": [
      "AuthCheckGetCompany",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthGetDailyReportByIdResponse": [
      "AuthCheckGetDailyReportById",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthGetDailyReportsByDayStatsResponse": [
      "AuthCheckGetDailyReportsByDayStats",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthGetDailyReportsByMachineIdStatsResponse": [
      "AuthCheckGetDailyReportsByMachineIdStats",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthGetDailyReportsReponse": [
      "AuthCheckGetDailyReports",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthGetEmployeesResponse": [
      "AuthCheckGetEmployees",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthGetInvitationsResponse": [
      "AuthCheckGetInvitations",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthGetMachineByIdResponse": [
      "AuthCheckGetMachineById",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthGetMachineGroupCountsResponse": [
      "AuthCheckGetMachineGroupCounts",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthGetMachinesResponse": [
      "AuthCheckGetMachines",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthGetMyDailyReportsResponse": [
      "AuthCheckGetMyDailyReports",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthGetUploadMachinesPresignatedUrlResponse": [
      "AuthCheckGetUploadMachinesPresignatedUrl",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthGetUsersResponse": [
      "AuthCheckGetUsers",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthUpdateCompanyResponse": [
      "AuthCheckUpdateCompany",
      "AuthorizationError",
      "ServerError"
    ],
    "AuthUpdateDailyReportResponse": [
      "AuthCheckUpdateDailyReport",
      "AuthorizationError",
      "NotFoundDailyReportError",
      "ServerError"
    ],
    "AuthUpdateProjectResponse": [
      "AuthCheckUpdateProject",
      "AuthorizationError",
      "DuplicatedProjectError",
      "ServerError"
    ],
    "BatchAddAvailableReportResponse": [
      "DailyReportItems"
    ],
    "CancelWorkOrderPayload": [
      "ItemWorkOrder",
      "NotAllowedError"
    ],
    "CursorPaginatedResponse": [],
    "DailyReportResponse": [
      "DailyReportItem"
    ],
    "DashBoard": [
      "OtherProjectsStats",
      "ProjectStats"
    ],
    "DeleteMachineConsumablePayload": [
      "MachineConsumableItem",
      "ResourceInUseError"
    ],
    "DeletePayload": [
      "DeleteIds",
      "ResourceInUseError"
    ],
    "DeleteWorkOrderPayload": [
      "IDUnionWrapper",
      "NotAllowedError"
    ],
    "DocumentPayload": [
      "ItemDocument"
    ],
    "EmployeeInterface": [
      "Employee",
      "Me"
    ],
    "Error": [
      "AuthorizationError",
      "BilderitPlanAlreadyCopiedError",
      "ConsumablesConflictError",
      "DuplicatedEntryError",
      "DuplicatedMachineError",
      "DuplicatedProjectError",
      "DuplicatedRoleError",
      "NotAllowedError",
      "NotFoundDailyReportError",
      "NotFoundInvitationError",
      "NotFoundRoleError",
      "ProfileDataMissingError",
      "ResourceInUseError",
      "ServerError",
      "UserNotSignedUpError",
      "WorkOrderStatusChangeError"
    ],
    "FacetGroup": [
      "MachineHistoryFacetGroup"
    ],
    "FacetedResponse": [
      "MachineHistoryConnection"
    ],
    "GetFuelDispatchedReportsReponse": [
      "GetFuelDispatchedReports"
    ],
    "GetMeResponse": [
      "GetMe",
      "ProfileDataMissingError",
      "ServerError",
      "UserNotSignedUpError"
    ],
    "GetStockControlReportsReponse": [
      "GetStockControlReports"
    ],
    "ImportBilderitMaintenancePlanResponse": [
      "BilderitPlanAlreadyCopiedError",
      "ConsumablesConflictError",
      "DuplicatedEntryError",
      "MaintenancePlan"
    ],
    "MachineHistoryEvent": [
      "MachineAssignmentHistoryEvent",
      "MachineCheckInHistoryEvent",
      "MachineCheckOutHistoryEvent",
      "MachineChecklistHistoryEvent",
      "MachineMoveHistoryEvent",
      "MachineNoticeHistoryEvent",
      "MachineOutOfServiceHistoryEvent",
      "MachineServiceHistoryEvent",
      "MachineWorkOrderHistoryEvent"
    ],
    "OffsetPaginatedResponse": [
      "AdminUsersResult",
      "CertificationHistoryConnection",
      "ChecklistTemplatesResponse",
      "ChecklistsResponse",
      "MachineHistoryConnection",
      "MachineNoticeDashboardConnection",
      "PaginatedUsers",
      "WorkOrdersConnection"
    ],
    "RegisterWorkOrderTasksPayload": [
      "ItemWorkOrder"
    ],
    "RejectInvitationResponse": [
      "NotFoundInvitationError",
      "RejectInvitation",
      "ServerError"
    ],
    "Result": [
      "ServerError",
      "SuccessResult"
    ],
    "SetWorkOrderStatusPayload": [
      "ItemWorkOrder",
      "WorkOrderStatusChangeError"
    ],
    "TelemetryDevice": [
      "IntegrationTelemetryDevice",
      "TrackerTelemetryDevice"
    ],
    "UnregisterWorkOrderTasksPayload": [
      "ItemWorkOrder"
    ],
    "UpdateFederatedIdentityInformationResponse": [
      "DuplicatedEntryError",
      "MeItem"
    ],
    "UpdateFixedAssetResponse": [
      "DuplicatedMachineError",
      "Machine"
    ],
    "UpdateFuelDispatchedReportPayload": [
      "FuelDispatchedReport"
    ],
    "UpdateHeavyEquipmentResponse": [
      "DuplicatedMachineError",
      "Machine"
    ],
    "UpdateMachineConsumablePayload": [
      "MachineConsumableItem"
    ],
    "UpdateMachinePayload": [
      "DuplicatedMachineError",
      "ItemMachine"
    ],
    "UpdateMaintenancePlanPayload": [
      "MaintenancePlanItem"
    ],
    "UpdateMeResponse": [
      "DuplicatedEntryError",
      "ServerError",
      "UpdateMe"
    ],
    "UpdateMobilityResponse": [
      "DuplicatedMachineError",
      "Machine"
    ],
    "UpdateNextServicePayload": [
      "ItemMachine"
    ],
    "UpdateStockControlReportPayload": [
      "StockControlReport"
    ],
    "UpdateTruckResponse": [
      "DuplicatedMachineError",
      "Machine"
    ],
    "UpdateWorkOrderPayload": [
      "ItemWorkOrder"
    ],
    "WorkOrderTaskConsumable": [
      "MachineConsumable",
      "StringUnionWrapper"
    ]
  }
}